export interface Role {
  name: string
  permissions: {}
}

export const roleConverter: firebase.firestore.FirestoreDataConverter<Role> = {
  toFirestore: (role) => {
    return {
      name: role.name,
      permissions: role.permissions
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    return {
      name: data.name,
      permissions: data.permissions
    }
  }
}
